import React from "react";
import { TextBuilderConfigType, getDefaultValues } from "../../../TextBuilder";
import { uuid } from "../../../../helpers/utils";
import {
  CONTACT_US_LINK,
  INDIA_WORK_AUTHORIZATION_DOC_URL,
  INDIA_WORK_EMPLOYEE_GUIDE_URL,
  ON_BASE_ONLINE_MY_DOCS_LOGIN_URL,
  PHILIPPINES_WORK_AUTHORIZATION_GUIDE_URL,
} from "../../../../utility/constants";
import LinkWithRedirect from "../../../common/LinkWithRedirect";
import { HVH_COLORS } from "../../../../config/palette";

export const nonCompleteInstructionConfigUpdated: TextBuilderConfigType = (arb) => ({
  ...getDefaultValues([
    {
      text: arb.formatMessage("Checklist-WorkAuthorization-Instruction-Without-Deadline", {
        link: <LinkWithRedirect link={CONTACT_US_LINK} messageKey="Checklist-Common-Here" messagePlaceholder="here" />,
      }),
      key: uuid(),
    },
  ]),

  IN: [
    {
      text: `${arb.formatMessage("Checklist-WorkAuthorization-Instruction-Without-Deadline", {
        link: <LinkWithRedirect link={CONTACT_US_LINK} messageKey="Checklist-Common-Here" messagePlaceholder="here" />,
      })} ${arb.getMessage("Checklist-WorkAuthorization-Instruction-Additional-IN")}`,
      key: uuid(),
    },
  ],
});

export const nonCompleteInstructionConfig: TextBuilderConfigType = (arb) => ({
  ...getDefaultValues([]),

  IN: [
    {
      text: arb.getMessage(
        "Checklist-RightToWork-Detail-GeneralMessage-IN",
        "You must complete the work authorization process to show your right to work in India. Read and follow the steps below to complete the process."
      ),
      key: uuid(),
    },
    {
      text: arb.getMessage(
        "Checklist-RightToWork-Detail-CitizenMessage-IN",
        "If you are an Indian Citizen, work authorization documentation is not required. There are no required actions to be completed for work authorization."
      ),
      prefixText: "1. ",
      key: uuid(),
    },
    {
      text: arb.formatMessage("Checklist-RightToWork-Detail-NonCitizenMessage-IN", {
        acceptableDocumentation: (
          <LinkWithRedirect
            link={INDIA_WORK_EMPLOYEE_GUIDE_URL}
            messageKey="Checklist-MainPage-Common-AcceptableDocumentation"
            messagePlaceholder="acceptable documentation"
          />
        ),
      }),
      prefixText: "2. ",
      key: uuid(),
    },
    {
      text: arb.getMessage(
        "Checklist-RightToWork-Detail-DeadlineMessage-IN",
        "For example, if your start date is on a Monday, your deadline is the following Monday. A ticket will be opened to collect and review documentation."
      ),
      key: uuid(),
    },
    {
      text: arb.formatMessage("Checklist-RightToWork-Detail-NoteMessage-IN", {
        workAuthorization: (
          <LinkWithRedirect
            link={INDIA_WORK_AUTHORIZATION_DOC_URL}
            messageKey="Checklist-RightToWork-WorkAuthorizationLink-IN"
            messagePlaceholder="Work Authorization - IND"
          />
        ),
      }),
      key: uuid(),
    },
  ],

  PH: [
    {
      text: arb.getMessage(
        "Checklist-RightToWork-Detail-GeneralMessage-PH",
        "Before Day 1, you must complete the work authorization process to show your right to work in the Philippines . Read and follow the steps below to complete the process."
      ),
      key: uuid(),
    },
    {
      text: arb.formatMessage("Checklist-RightToWork-Detail-DeclarationMessage-PH", {
        i9Link: <LinkWithRedirect link={ON_BASE_ONLINE_MY_DOCS_LOGIN_URL} messageKey="Checklist-MainPage-Link" />,
      }),
      prefixText: "1. ",
      key: uuid(),
    },
    {
      text: arb.getMessage(
        "Checklist-RightToWork-Detail-CitizenMessage-PH",
        "If you are a Filipino citizen, no further action is required."
      ),
      prefixText: "2. ",
      key: uuid(),
    },
    {
      text: arb.formatMessage("Checklist-RightToWork-Detail-NonCitizenMessage-PH", {
        i9Link: (
          <LinkWithRedirect link={PHILIPPINES_WORK_AUTHORIZATION_GUIDE_URL} messageKey="Checklist-MainPage-Link" />
        ),
      }),
      prefixText: "3. ",
      key: uuid(),
    },
    {
      text: arb.getMessage(
        "Checklist-RightToWork-Detail-WithdrawMessage-PH",
        "If you are unable to complete this process, you will not be allowed to start work; your start date may be pushed out or your offer of employment may be withdrawn."
      ),
      key: uuid(),
    },
    {
      text: arb.getMessage(
        "Checklist-RightToWork-Detail-NoteMessage-PH",
        "Note: If you are in the progress of getting a Philippine work visa, return to this step when you receive it."
      ),
      key: uuid(),
      fontColor: HVH_COLORS.NEUTRAL_70,
    },
  ],

  IE: [
    {
      text: arb.formatMessage("Checklist-WorkAuthorization-Instruction", {
        deadline: (
          <b>
            {arb.getMessage(
              "Checklist-WorkAuthorization-Instruction-Deadline",
              "7 calendar days prior to your start date"
            )}
          </b>
        ),
        link: <LinkWithRedirect link={CONTACT_US_LINK} messageKey="Checklist-Common-Here" messagePlaceholder="here" />,
      }),
      key: uuid(),
    },
  ],

  ZA: [
    {
      text: arb.formatMessage("Checklist-WorkAuthorization-Instruction", {
        deadline: (
          <b>
            {arb.getMessage(
              "Checklist-WorkAuthorization-Instruction-Deadline",
              "7 calendar days prior to your start date"
            )}
          </b>
        ),
        link: <LinkWithRedirect link={CONTACT_US_LINK} messageKey="Checklist-Common-Here" messagePlaceholder="here" />,
      }),
      key: uuid(),
    },
  ],

  JP: [
    {
      text: arb.formatMessage("Checklist-WorkAuthorization-Instruction", {
        deadline: (
          <b>
            {arb.getMessage(
              "Checklist-WorkAuthorization-Instruction-Deadline",
              "7 calendar days prior to your start date"
            )}
          </b>
        ),
        link: <LinkWithRedirect link={CONTACT_US_LINK} messageKey="Checklist-Common-Here" messagePlaceholder="here" />,
      }),
      key: uuid(),
    },
  ],
});
